import React from 'react';
import type { FC, PropsWithChildren } from 'react';

import WidgetLoaderManager from '../WidgetLoaderManager/WidgetLoaderManager';
import type { AppEnv } from '../../shared/types/app/AppEnv';
import ErrorCard from '../ErrorCard/ErrorCard';

type ContainerAppEnvChekoutSessionProps = {
  checkoutSessionId?: string;
  appEnv: AppEnv;
};

const ContainerAppEnvChekoutSession: FC<
  PropsWithChildren<ContainerAppEnvChekoutSessionProps>
> = ({ checkoutSessionId, children, appEnv }) => {
  if (!(checkoutSessionId && appEnv)) {
    return <ErrorCard />;
  }
  return (
    <WidgetLoaderManager
      appEnv={appEnv}
      checkoutSessionId={checkoutSessionId}
    >
      {children}
    </WidgetLoaderManager>
  );
};

export default ContainerAppEnvChekoutSession;
